import React from 'react';
import ItemRateReportFunctional from './components/item-rate-report-list-functional';
import './item-rate-report.scss';

const ItemRateReport = () => {
	return <ItemRateReportFunctional />;
};

export default ItemRateReport;
